// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmojiList__container-b0813a {
  padding-top: 6px;
  padding-bottom: 4px;
  padding-inline-start: 8px;
  padding-inline-end: 4px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  flex: 1;
  overflow-y: auto;
}

.EmojiList__category-ee03b2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/EmojiPanel/EmojiList/EmojiList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  padding-top: 6px;\n  padding-bottom: 4px;\n  padding-inline-start: 8px;\n  padding-inline-end: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.category {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EmojiList__container-b0813a`,
	"category": `EmojiList__category-ee03b2`
};
module.exports = ___CSS_LOADER_EXPORT___;
